import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { VideoModal } from "@/components/public/VideoModal";

const SEEN_KEY = "mmm_welcome_seen";

// First-time-visitor welcome video pop-out (homepage only). Also controllable
// via the `open` prop (used by the "Watch Welcome Video" replay button).
export const WelcomeVideo = ({ content, open = false, onOpenChange }) => {
  const wv = content?.welcome_video || {};
  const configured = !!(wv.enabled && wv.video_url);
  const location = useLocation();
  const [auto, setAuto] = useState(false);

  useEffect(() => {
    if (!configured || location.pathname !== "/") return undefined;
    let seen = false;
    try { seen = localStorage.getItem(SEEN_KEY) === "1"; } catch (e) { seen = false; }
    if (seen) return undefined;

    const timing = wv.timing || "delay";
    let timer;
    let onScroll;
    if (timing === "immediately") {
      timer = setTimeout(() => setAuto(true), 500);
    } else if (timing === "scroll") {
      onScroll = () => {
        if (window.scrollY > 300) {
          setAuto(true);
          window.removeEventListener("scroll", onScroll);
        }
      };
      window.addEventListener("scroll", onScroll, { passive: true });
    } else {
      const secs = Number(wv.delay_seconds) > 0 ? Number(wv.delay_seconds) : 5;
      timer = setTimeout(() => setAuto(true), secs * 1000);
    }
    return () => {
      if (timer) clearTimeout(timer);
      if (onScroll) window.removeEventListener("scroll", onScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configured, location.pathname]);

  if (!configured) return null;

  const isOpen = open || auto;
  const handleOpenChange = (o) => {
    if (!o) {
      setAuto(false);
      try { localStorage.setItem(SEEN_KEY, "1"); } catch (e) { /* ignore */ }
      if (onOpenChange) onOpenChange(false);
    }
  };

  return (
    <VideoModal
      open={isOpen}
      onOpenChange={handleOpenChange}
      url={wv.video_url}
      title={wv.title}
      description={wv.description}
      poster={wv.poster_url}
      buttonLabel={wv.button_label || "Watch Welcome Video"}
      testid="welcome-video-modal"
    />
  );
};

export default WelcomeVideo;
